import { isRejectedWithValue, Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { showMessage } from '@/app/store/fuse/messageSlice';

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const data = action.payload as { status: number };
    if (data?.status === 401) {
      api.dispatch(
        showMessage({
          message: 'Unauthorized',
          variant: 'error',
        }),
      );
      return;
    }
    api.dispatch(
      showMessage({
        message:
          (action.payload as { data: string } | undefined)?.data ||
          (action.payload as string) ||
          'Something went wrong!',
        variant: 'error',
      }),
    );
  }

  return next(action);
};
